import { AppointmentsRepository } from "@/repositories/appointments.repository";
import { appointment_status } from "@/models/appointment.model";

export async function listIndividualAppointments(
  page: number,
  pageSize: number,
  filters: {
    status?: appointment_status;
    serviceParent?: string;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  },
  sortKey: string,
  sortOrder: "asc" | "desc"
) {
  return AppointmentsRepository.listForIndividual(page, pageSize, filters, sortKey, sortOrder);
}

export const listIndividualAppointmentFilterOptions = async () => {
  return AppointmentsRepository.listFilterOptionsForIndividual();
};

// Detail page functions
export const fetchIndividualAppointment = (id: string) => AppointmentsRepository.getById(id);
export const fetchIndividualAppointmentLogs = (id: string) => AppointmentsRepository.listHistory(id);
